import React, {Fragment} from "react";
import request from "superagent";
import * as R from 'ramda'
import moment from 'moment';

export const isNotEmptyArr = (arr) => 
  arr && Array.isArray(arr) && arr.length > 0 && arr[0] !== undefined

export const isEmpty = (obj) => {
  for (var key in obj) {
    return false;

  }
  return true;
}
const is_Empty = (prop) => (
  prop === null ||
  prop === undefined ||
  (prop.hasOwnProperty('length') && prop.length === 0) ||
  (prop.constructor === Object && Object.keys(prop).length === 0)
);

export const toDateFormat = (val) => {
  if (R.not(val)) return null
  const arrVal = val.substring(0,10).split('-')
  if (arrVal && arrVal.length == 3){
    const dat = `${arrVal[2]}.${arrVal[1]}.${arrVal[0]}`
    return dat
  }
  else
    return '';
}
export const toDateFormatJSON = (val,sep) => {
  if (R.not(val)) return null
  const arrVal = val.substring(0,10).split(sep)
  if (arrVal && arrVal.length == 3){
    const dat = `${arrVal[2]}-${arrVal[1]}-${arrVal[0]}`
    return dat
  }
  else
    return '';
}

export const isDateVal = (val) => {
  const arrVal = val.split('.')
  if (arrVal && arrVal.length == 3){
    const dat = `${arrVal[1]}.${arrVal[0]}.${arrVal[2]}`
    return moment(dat)._isValid
  }
  else
    return false;
}

export const HandleFindError = (obj) => {
  if (!isEmpty(obj)){
     const {is_error,error_text} = obj
     if (is_error && is_error == 1) 
        return {is_err : true , mess : error_text||null} 
  }
  return {is_err : false , mess : null} 
}

export const mutableList = (list,id,name) => {
  if (!isNotEmptyArr(list)) 
    return [{value : null, label : "Нет данных"}]
  return list.reduce(
    (result, elem) =>
     [...result, {value : elem[id],
                 label : elem[name]} ],
     []
   )
  }
  export const mutablePickList = (list,id,name) => {
    if (!isNotEmptyArr(list)) 
      return [{value : null, label : "Нет данных"}]
    return list.reduce(
      (result, elem) =>
       [...result, {id : elem[id],
                   title : elem[name]} ],
       []
     )
    }
    export const mutableListSel = (list,val,lab,field1 = '',field2 = '') => {
      if (isEmpty(list)) 
      return [{value: "", label: "Нет данных"}]
      const countlab = 17       
      return list.reduce(
       (result, elem) => {
          let fiel1 = elem[field1] ? elem[field1] : ''
          let fiel2 = elem[field2] ? elem[field2] : ''
          let elemlab = elem[lab] ? elem[lab] : ''
          //elemlab = typeof elemlab === 'string' ? elemlab.substring(0,countlab) : elemlab
         return [...result, {value : elem[val],label : `${elemlab} ${fiel1} ${fiel2}`} ]
        }, []
      )
    }
    export const mutableListSelDef = (list,val,lab,field1 = '',field2 = '') => {
      if (isEmpty(list)) 
      return [{value: "", label: "Нет данных"}]
      return list.reduce(
       (result, elem) => {
          let fiel1 = elem[field1] ? elem[field1] : ''
          let fiel2 = elem[field2] ? elem[field2] : ''
          let elemlab = elem[lab] ? elem[lab] : ''
          //elemlab = typeof elemlab === 'string' ? elemlab.substring(0,countlab) : elemlab
         return [...result, {value : elem[val],label : `${elemlab} ${fiel1} ${fiel2}`} ]
        }, [{value : 0,label : ``}]
      )
    }
    export const mutableListSelect = list => {
      if (isEmpty(list))
        return [{ value: "", label: "Нет данных" }]
    
      return list.reduce(
        (result, elem) =>
          [...result, {
            value: elem.id,
            label: elem.title
          }],
        []
      )
    }
        
export const CustomFormatter = (text,short=text,color=null,background=null,opacity=1) => {
    let style = {};
    if ( color )  style.color = color;
    if ( background ) style.backgroundColor = background;
    style.height = '50px'         
    style.marginTop = '-3px'         
    style.marginLeft = '-7px'         
    style.marginRight = '-8px'         
    style.marginBottom = '-20px'         
    style.textAlign = 'center'
    style.fontSize = '80%'
    style.fontWeight = '100'
    style.fontFamily = 'Arial'
    style.opacity = opacity
    //style.wordWrap = 'break-word'
    //style.wordBreak = 'break-all' 
  return (color || background) ? (<div style={style} title={text}>{short}</div> ) : (<div>{text}</div>);
  };

/*
  Функция для отбора данных 
*/
export const SumTotalVid = (data) => {
  let datatotalvid = [{
    'vidp': 'Плановая',
    'planh': 0,
    'facth': 0,
    'percent': 0
   },
   {
    'vidp': 'Внеплановая',
    'planh': 0,
    'facth': 0,
    'percent': 0
   },
   {
    'vidp': 'MFSM',
    'planh': 0,
    'facth': 0,
    'percent': 0
   }]
  
  if (!isNotEmptyArr(data)) return datatotalvid
  datatotalvid.map((dat) => {
    Object.keys(data[0]).map((key) => {
      if (key == 'planh'||key == 'facth')        
        dat[key] = data.filter(x=> x.vidp===dat.vidp.substr(0,1)).reduce((result, elem) => result+elem[key], 0)
      })
  })

  return datatotalvid
}

export const SumTotalRow = (data) => {
  let datatotalrow = {isTotalRow: true,id: 0,datan: null,datak: null,planh: 0,facth: 0,done:0,
     d01:0,d02:0,d03:0,d04:0,d05:0,d06:0,d07:0,d08:0,d09:0,d10:0,d11:0,d12:0,d13:0,d14:0,d15:0, 
     d16:0,d17:0,d18:0,d19:0,d20:0,d21:0,d22:0,d23:0,d24:0,d25:0,d26:0,d27:0,d28:0,d29:0,d30:0,d31:0}

  if (!isNotEmptyArr(data)) return datatotalrow

  Object.keys(data[0]).map((key) => {
    if (key == 'planh'||key == 'facth'||(key.length==3 && key.substr(0,1) == 'd'))        
      datatotalrow[key] = data.reduce((result, elem) => result+elem[key], 0)
    if (key == 'done')        
      datatotalrow[key] = data.reduce((result, elem) => result+(elem[key]=='+'?1:0), 0)
    })

  return datatotalrow
}

export const filterDataChoisePack = (dataArray, filter , name_columns) =>
  {
    let filteredArray = dataArray.filter(data => {
      //console.log('filterDataChoise',filter,name_columns);
      if (R.not(filter.turn)) return true;

      let found = false;

      Object.keys(data).map((key) => {
       // console.log('key,name_columns',key,name_columns)
        if (R.contains(key,name_columns)){
          if (typeof(data[key]) === 'string'){
               //console.log('filter[key],data[key]',filter[key],data[key],key)
               if (filter[key])
                 found = found || R.contains(filter[key],data[key])
               else {
                 if (key === 'datesupply'&&filter['day01']&&filter['day02']) {
                  let startDate = moment(filter['day01']).toDate()
                  let endDate   = moment(filter['day02']).toDate()
                  let date  = moment(data[key]).toDate()
                  found = found || (date > startDate && date < endDate)
                 }
               }  
               //console.log('found',found)
           }
           if (typeof(data[key]) === 'number'){
            let datakey = String(data[key])
            if (filter[key])
               found = found || R.contains(filter[key],datakey)
           }
          }
      });
      return found;
    });
    //console.log('filteredArray--',filteredArray);

    return filteredArray;
  }

  export const filterDataChoiseSpis = (dataArray, filter , name_columns,key) =>
  {
    if (isEmpty(dataArray)) return false
    let filteredArray = dataArray.filter(data => {
      if (isEmpty(filter)) return true
       
      let found = false;
      found = found || (filter[key] === data[key])

      return found;
    });
    //console.log('filteredArray--',filteredArray);

    return filteredArray;
}

function sleep(delay = 0) {
  return new Promise((resolve) => {
    setTimeout(resolve, delay);
  });
}

export const FetchLiteUrl = async (strUrl, post, userarg, thisMock, mockdata, mockdataempty = {}) =>  {
  if (thisMock||strUrl=='') {
    await sleep(200); 
    return new Promise((resolve, reject) => { resolve(mockdata); });
  } else {
    if (!post) {
      const { body } = await request.get(strUrl);
      return body;
    } else {
      try {
        const { body } = await request
          .post(strUrl)
          .set("Content-Type", "application/json")
          .send({ ...userarg });
        return body;
      }
      catch { 
        return mockdataempty;
      }
    }
  }

}
export const computeRow = () => {
  if (window.matchMedia(`(max-width: 800px)`).matches)
      return 9
  if (window.matchMedia(`(max-width: 900px)`).matches)
      return 10
  if (window.matchMedia(`(max-width: 1100px)`).matches)
      return 11
  if (window.matchMedia(`(max-width: 1200px)`).matches)
      return 12
  if (window.matchMedia(`(max-width: 1300px)`).matches)
      return 12
  if (window.matchMedia(`(max-width: 1400px)`).matches)
      return 13
  if (window.matchMedia(`(max-width: 1500px)`).matches)
      return 14
  if (window.matchMedia(`(max-width: 1600px)`).matches)
      return 15
  if (window.matchMedia(`(max-width: 1700px)`).matches)
      return 18
  if (window.matchMedia(`(max-width: 1800px)`).matches)
      return 22
  if (window.matchMedia(`(max-width: 1900px)`).matches)
      return 22
  if (window.matchMedia(`(max-width: 2000px)`).matches)
      return 25
  if (window.matchMedia(`(max-width: 2100px)`).matches)
      return 25
  if (window.matchMedia(`(max-width: 2400px)`).matches)
      return 25

   return 25
}
export const computeRowOne = () => {
  if (window.matchMedia(`(max-width: 800px)`).matches)
      return 5
  if (window.matchMedia(`(max-width: 900px)`).matches)
      return 6
  if (window.matchMedia(`(max-width: 1100px)`).matches)
      return 6
  if (window.matchMedia(`(max-width: 1200px)`).matches)
      return 8
  if (window.matchMedia(`(max-width: 1300px)`).matches)
      return 8
  if (window.matchMedia(`(max-width: 1400px)`).matches)
      return 9
  if (window.matchMedia(`(max-width: 1500px)`).matches)
      return 10
  if (window.matchMedia(`(max-width: 1600px)`).matches)
      return 12
  if (window.matchMedia(`(max-width: 1700px)`).matches)
      return 12
  if (window.matchMedia(`(max-width: 1800px)`).matches)
      return 14
  if (window.matchMedia(`(max-width: 1900px)`).matches)
      return 15
  if (window.matchMedia(`(max-width: 2000px)`).matches)
      return 17
  if (window.matchMedia(`(max-width: 2100px)`).matches)
      return 17
  if (window.matchMedia(`(max-width: 2400px)`).matches)
      return 17

   return 17
}

export const computeRowTwo = () => {
  if (window.matchMedia(`(max-width: 800px)`).matches)
      return 3
  if (window.matchMedia(`(max-width: 900px)`).matches)
      return 4
  if (window.matchMedia(`(max-width: 1100px)`).matches)
      return 4
  if (window.matchMedia(`(max-width: 1200px)`).matches)
      return 4
  if (window.matchMedia(`(max-width: 1300px)`).matches)
      return 6
  if (window.matchMedia(`(max-width: 1400px)`).matches)
      return 6
  if (window.matchMedia(`(max-width: 1500px)`).matches)
      return 6
  if (window.matchMedia(`(max-width: 1600px)`).matches)
      return 7
  if (window.matchMedia(`(max-width: 1700px)`).matches)
      return 7
  if (window.matchMedia(`(max-width: 1800px)`).matches)
      return 10
  if (window.matchMedia(`(max-width: 1900px)`).matches)
      return 10
  if (window.matchMedia(`(max-width: 2000px)`).matches)
      return 10
  if (window.matchMedia(`(max-width: 2100px)`).matches)
      return 10
  if (window.matchMedia(`(max-width: 2400px)`).matches)
      return 10

   return 10
}

export const parsingCss = (data,css,key,child) => {
  
  if (!isNotEmptyArr(data)) return ''
  data.map(el => {
    if (el[key] && el[key].length) 
      css = css+'\n'+el[key]   
    if (el[child] && isNotEmptyArr(el[child])) 
      css = parsingCss(el[child],css,key,child)      
   })
  return css
 }

export const Spinner = () => <Fragment>  
<div className="spinner-cont">
 <div className="TB_overlay"></div>
 <div className="wait-text">Загрузка...</div>
 <div className="wait block">
   <div className="sk-circle">
     <div className="sk-circle1 sk-child"></div>
     <div className="sk-circle2 sk-child"></div>
     <div className="sk-circle3 sk-child"></div>
     <div className="sk-circle4 sk-child"></div>
     <div className="sk-circle5 sk-child"></div>
     <div className="sk-circle6 sk-child"></div>
     <div className="sk-circle7 sk-child"></div>
     <div className="sk-circle8 sk-child"></div>
     <div className="sk-circle9 sk-child"></div>
     <div className="sk-circle10 sk-child"></div>
     <div className="sk-circle11 sk-child"></div>
     <div className="sk-circle12 sk-child"></div>
   </div>
 </div>
</div>
</Fragment>
  
  export const GridHeight = () => {
    if (window.matchMedia(`(max-height: 600px)`).matches)
      return '80vh'
    if (window.matchMedia(`(max-height: 700px)`).matches)
      return '85vh'
    if (window.matchMedia(`(max-height: 800px)`).matches)
      return '88vh'
    if (window.matchMedia(`(max-height: 900px)`).matches)
      return '88vh'
    if (window.matchMedia(`(max-height: 1000px)`).matches)
      return '92vh'
    if (window.matchMedia(`(max-height: 1100px)`).matches)
        return '95vh'
    if (window.matchMedia(`(max-height: 1200px)`).matches)
        return '95vh'
    if (window.matchMedia(`(max-height: 1300px)`).matches)
        return '95vh'
    if (window.matchMedia(`(max-height: 1400px)`).matches)
        return '95vh'
    if (window.matchMedia(`(max-height: 1500px)`).matches)
        return '95vh'
    if (window.matchMedia(`(max-height: 1600px)`).matches)
        return '95vh'
    if (window.matchMedia(`(max-height: 1700px)`).matches)
        return '95vh'
    if (window.matchMedia(`(max-height: 1800px)`).matches)
        return '95vh'
    if (window.matchMedia(`(max-height: 1900px)`).matches)
        return '95vh'
    if (window.matchMedia(`(max-height: 2000px)`).matches)
        return '95vh'
    if (window.matchMedia(`(max-height: 2100px)`).matches)
        return '95vh'
    if (window.matchMedia(`(max-height: 2400px)`).matches)
        return '95vh'
  
     return '95vh'
  }
  